import { create } from 'zustand'
interface AlertState {
    alertMessage: { type: 'success' | 'error'; message: string } | null
    setAlertMessage: (message: { type: 'success' | 'error'; message: string }) => void
    clearAlertMessage: () => void
}

export const useAlertifyStore = create<AlertState>((set) => ({
    alertMessage: null,
    setAlertMessage: (message) => set({ alertMessage: message }),
    clearAlertMessage: () => set({ alertMessage: null }),
}))
